<template>
  <div class="artists-box">
    <router-link
      v-for="(artist, key) in artists"
      :key="`artist-${key}`"
      :to="{ path: `/artists/${artist.slug}` }"
      v-slot="{ navigate }"
      custom
    >
      <div class="artists-box_card" @click="navigate">
        <div
          class="image"
          :style="{ backgroundImage: `url(${artist.search_image})` }"
          @click="$router.push({ path: `/artists/${artist.slug}` })"
        >
          <div class="image__preview"><p>Click to View</p></div>
        </div>
        <h3 class="name">{{ artist.full_name }}</h3>
        <div class="country">
          <span v-for="(i, idx) in artist.regions" :key="idx">
            {{ i.title }}<span v-if="idx < artist.regions.length - 1">,</span>
          </span>
        </div>
      </div>
    </router-link>
  </div>
</template>

<script>
export default {
  props: ["artists"],
};
</script>

<style lang="scss" scoped>
.artists-box {
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-column-gap: 3rem;
  grid-row-gap: 6.8rem;
  @media screen and (max-width: $md) {
    grid-template-columns: 1fr 1fr;
  }
  @media screen and (max-width: $xs) {
    grid-template-columns: 1fr;
  }

  &_card {
    @include flexColumnClickable;

    &-link {
      display: block;
      text-decoration: none;
    }
    .image {
      position: relative;
      @include imageContainer();
      @media screen and (max-width: $xs) {
        height: 90vw;
      }

      &__preview {
        @include imagePreview;

        p {
          @include imagePreviewParagraph;
        }
      }

      &:hover {
        .image__preview {
          @include imageHoverEffect;
        }
      }
    }

    .name {
      font-size: 2.4rem;
      line-height: 3.1rem;
      margin-top: 1.2rem;
      font-weight: 500;
    }

    .country {
      display: flex;
      flex-wrap: wrap;
      gap: 0 4px;
      margin-top: 0.8rem;
      @media screen and (max-width: $xs) {
        font-size: 1.4rem;
        line-height: 2.5rem;
      }
      span {
        &:last-of-type {
          span {
            display: none;
          }
        }
      }
    }
  }
}
</style>

